import { updateObject } from './../../utils/utility';

const initialState = {
    orderList: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listRefreshed: false,
    countryList: [],
    companyList: [],
    legalEntityList: [],    
    serviceTypes: []
};

const setIndirectCustomerOrderList = (state = initialState, action) => {
    const { orderList, totalOrder, pageNumber, totalPages, legalEntityList, countryList, companyList, serviceTypes } = action.data;
    return updateObject(state, {
        orderList,
        totalElements: totalOrder,
        pageNumber,
        totalPages,
        listRefreshed: true,
        countryList,
        companyList,
        legalEntityList,
        serviceTypes
    });
};

const updateSpecificOrderData = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { orderList } = state;
    orderList[rowIndex] = { ...orderList[rowIndex], [columnName]: value };
    return updateObject(state, { orderList });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_INDIRECT_CUSTOMER_ORDER_LIST") {
        return setIndirectCustomerOrderList(state, action);
    }
    else if (action.type === "UPDATE_SPECIFIC_ORDER_DATA") {
        return updateSpecificOrderData(state, action);
    }
    return state;
}

export default reducer;
